export const PROVIDER_XERO = 'xero';
export const PROVIDER_OUTLOOK = 'outlook';
export const PROVIDER_GMAIL = 'gmail';
export const PROVIDER_GOOGLE_DRIVE = 'google_drive';
export const PROVIDER_GOOGLE_SHEETS = 'google_sheets';
export const CONN_STATUS_SUCCESS = 'success';
export const CONN_STATUS_EXCEPTION = 'exception';
